import React, { useState, useEffect, useContext } from "react";
import { GameQuery } from "../../gql/queries";
import { useQuery } from "@apollo/client";
import { Link, useParams } from "react-router-dom";
import {
  MAX_PLAYERS,
  S3_BASE_URL,
  IMAGE_COLLECTABLE_9X16_DIR,
  IMAGE_COLLECTABLE_16X9_DIR
} from "../../config";
import { PlayerInfo } from "../../lib/models/PlayerInfo";
import { getProfileIconFromDisplayName } from "../../components/character-picker";
import classNames from "classnames";
import useCopy from "@react-hook/copy";
import Modal from "../modal";
import Button from "../button";
import { isMobile } from "react-device-detect";

//assets
import WinnerFrame from "../../assets/images/winner-frame.svg";
import "./game-results.scss";
import { UserContext } from "../UserContext";
import { motion } from "framer-motion";
import useWindowSize from "react-use/lib/useWindowSize";

import LoadingIndicator from "../LoadingIndicator";
import Snowfall from "react-snowfall";

const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      duration: 0.3
    }
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.35
    }
  }
};

const loadPlayerResultsInfo = (data: any) => {
  const players = [] as PlayerInfo[];
  for (let i = 1; i <= MAX_PLAYERS; i++) {
    const playerKey = `Player_${i}`;
    const playerId = data[playerKey];
    players.push({
      id: playerId,
      name: data[`${playerKey}_DisplayName`],
      round: data[`${playerKey}_Round`],
      score: data[`${playerKey}_Score`]
    });
  }
  return players;
};

declare const window: any;

const Result = (/*props*/) => {
  const { id, player_id } = useParams();
  const { loading, data, error } = useQuery(GameQuery, {
    variables: { id },
    fetchPolicy: "no-cache"
  });

  const { user } = useContext(UserContext);

  //let players: PlayerInfo[] = []
  const [players, setPlayers] = useState<PlayerInfo[]>([]);

  //prob should have used player object
  const [currentPlayer_id, setCurrentPlayerId] = useState("");
  const [currentCollectableKey, setCurrentCollectableKey] = useState("");

  const [currentPlayerScore, setCurrentPlayerScore] = useState(0);
  const [currentPlayerRank, setCurrentPlayerRank] = useState(0);
  const [showShareModal, setShowShareModal] = useState(false);
  const [showCollectableModal, setShowCollectableModal] = useState(false);
  const { width, height } = useWindowSize();

  //set the playerid to the current player or the one in the url
  useEffect(() => {
    if (player_id) {
      setCurrentPlayerId(player_id);
    } else {
      setCurrentPlayerId(user.id);
    }
  });

  // track page-view
  useEffect(() => {
    window.bindTracking({
      type: "dynamic-page",
      data: {
        pageviewevent: 1,
        screenName: "Results",
        screenSection: "Results",
        interactionName: "Results"
      }
    });
  }, []);

  useEffect(() => {
    if (data && data.getGame && !loading) {
      // console.log("qs", data);

      const unSortedPlayers = [...loadPlayerResultsInfo(data.getGame)];

      const sortedPlayers = unSortedPlayers.sort(function (a, b) {
        if (a.score > b.score) return -1;
        if (a.score < b.score) return 1;
        return 0;
      });

      setPlayers(sortedPlayers);

      // console.log("PLAYERS", sortedPlayers);

      let score = 0;
      let rank = 0;
      for (let i = 0; i < sortedPlayers.length; i++) {
        if (currentPlayer_id === sortedPlayers[i].id) {
          score = sortedPlayers[i].score;
          rank = i + 1;
          // console.log("SCORE");
        }
      }

      setCurrentPlayerRank(rank);
      setCurrentPlayerScore(score);
      getCurrentCollectableByScore(score);
    }
  }, [data]);

  const shareCopy = `I just played American Dad Trivia: Head to Head! Think you're an American Dad superfan? Play now and put your knowledge to the test.`;

  const { copied, copy, reset } = useCopy(
    `${shareCopy} #AmericanDadTrivia ${process.env.PUBLIC_URL}/collectable${currentCollectableKey}.html`
  );

  function handleShareClick() {
    window.bindTracking({
      type: "dynamic-page",
      data: {
        pageviewevent: 1,
        screenName: "Share Your Results",
        screenSection: "Results",
        interactionName: "Share Your Results"
      }
    });

    copy();

    setShowShareModal(true);

    //let shareURL = `${window.location.origin.toString()}/#/result/${id}/player/${currentPlayer_id}`;
    //alert(shareURL);
  }

  function handleDownloadClick() {
    window.bindTracking({
      type: "dynamic-page",
      data: {
        pageviewevent: 1,
        screenName: "Your Collectable",
        screenSection: "Your Collectable",
        interactionName: "Your Collectable"
      }
    });

    setShowCollectableModal(true);
  }

  //get the collectable the user based on their score -- this is in a json file that can be created using admin tool
  function getCurrentCollectableByScore(score: number) {
    let collectablesData = require(`../../data/collectablesData.json`);

    for (var i = 0; i < collectablesData.length; i++) {
      const collectable = collectablesData[i];

      const ScoreRangeLow = parseInt(collectable.ScoreRangeLow);
      const ScoreRangeHigh = parseInt(collectable.ScoreRangeHigh);

      if (score >= ScoreRangeLow && score <= ScoreRangeHigh) {
        //console.log("COLLECTABLE", collectable.collectableKey)
        setCurrentCollectableKey(collectable.collectableKey);
      }

      //console.log("COLLECTABLE", collectable)
    }
  }

  //preload collectable
  useEffect(() => {
    if (currentCollectableKey) {
      const img = new Image();
      const imgTwo = new Image();
      img.src = `${S3_BASE_URL}${IMAGE_COLLECTABLE_9X16_DIR}/${currentCollectableKey}.png`;
      imgTwo.src = `${S3_BASE_URL}${IMAGE_COLLECTABLE_16X9_DIR}/${currentCollectableKey}.png`;
    }
  }, [currentCollectableKey]);

  //show loading message
  if (loading || !data || players.length == 0) {
    return <LoadingIndicator />;
  }

  const activePlayersCount = players.filter(player => player.id).length;



  const postToFB = () => {
    window.bindTracking({
      type: "interaction-event",
      data: {
        interactionEvent: 1,
        screenName: "Share Your Results",
        screenSection: "Results",
        interactionName: "Facebook Results Share"
      }
    });

    const url = `${process.env.PUBLIC_URL}/collectable${currentCollectableKey}.html`;
    // const href = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
    const href = `https://www.facebook.com`;
    window.open(href);

    setShowShareModal(false);
  };

  const postToTwitter = () => {
    window.bindTracking({
      type: "interaction-event",
      data: {
        interactionEvent: 1,
        screenName: "Share Your Results",
        screenSection: "Results",
        interactionName: "Twitter Results Share"
      }
    });

    const url = `${process.env.PUBLIC_URL}/collectable${currentCollectableKey}.html`;
    const href = `https://twitter.com/intent/tweet?text=${encodeURI(
      shareCopy
    )}&hashtags=AmericanDadTrivia&url=${encodeURI(url)}`;

    window.open(href);

    setShowShareModal(false);
  };

  const downloadCollectable = () => {
    //EVENT LOGGING
    window.bindTracking({
      type: "interaction-event",
      data: {
        interactionEvent: 1,
        screenName: "Your Collectable",
        screenSection: "Your Collectable",
        interactionName: "Download Collectable"
      }
    });

    let imageURL = `${S3_BASE_URL}${IMAGE_COLLECTABLE_9X16_DIR}/download/${currentCollectableKey}.png`;

    //https://tbstnt-vendor-glow-americandad-quiz300.s3.amazonaws.com/images/collectables/9x16/download/DirectorBullock.png

    if (!isMobile) {
      fetch(imageURL)
        .then(img => img.blob())
        .then(blob => {
          let url = window.URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.href = url;
          link.download = `${currentCollectableKey}.png`;
          link.click();
        });
    } else {
      window.open(
        `${S3_BASE_URL}${IMAGE_COLLECTABLE_9X16_DIR}/${currentCollectableKey}.png`
      );
    }
  };

  return (
    <div className="inner-container">
      <motion.div
        className="game-results-outer"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        exit="exit"
      >
        
        <Modal
          title="Share Your Results!"
          isOpen={showShareModal}
          closeModal={() => setShowShareModal(false)}
        >
          <div className="join-game-modal">
            <div className="copy">{shareCopy} #AmericanDadTrivia</div>

            <div className="buttons flex items-center justify-center flex-col">
              <Button color="blue" onClick={() => postToFB()}>
                Copy URL & Share to Facebook
              </Button>
              <Button color="blue" onClick={() => postToTwitter()}>
                Post To Twitter
              </Button>
            </div>
          </div>
        </Modal>
        <Modal
          title="Your Collectible"
          isOpen={showCollectableModal}
          closeModal={() => setShowCollectableModal(false)}
        >
          <div className="collectable-modal">
            <div className="collectable-image">
              <img
                src={`${S3_BASE_URL}${IMAGE_COLLECTABLE_9X16_DIR}/${currentCollectableKey}.png`}
                className=""
                alt=""
              />
            </div>
            <div className="copy text-center mx-auto">
              The closer to 5 stars, the more power your card holds! Download
              below to share.
            </div>
            <div className="buttons">
              <Button color="red" onClick={() => downloadCollectable()}>
                Download
              </Button>
            </div>
          </div>
        </Modal>
        <div
          className={classNames({
            "game-results": true,
            "no-scores": !players[0].score,
            private: activePlayersCount === 1
          })}
        >
          <motion.div className={classNames({
            "results-inner": true,
          })}
          initial={{opacity:0}}
          animate={{opacity: 1}}
          transition={{delay: 0.5}}>

            {!!players[0].score && (
              <motion.div
                className="flex items-center justify-center w-full"
                initial={{ opacity: 0, scale: 0 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{
                  type: "spring",
                  stiffness: 300,
                  damping: 20,
                  
                }}
              >
                <div
                  className="first-place"
                  style={{ backgroundImage: `url(${WinnerFrame})` }}
                >
                  {players[0].id && (
                    <>
                      <div
                        className="first-place-persona"
                        style={{
                          backgroundImage: `url(${getProfileIconFromDisplayName(
                            players[0].name
                          )})`
                        }}
                      ></div>
                      <div
                        className={classNames({
                          "first-place-name": true,
                          medium: players[0].name.length >= 15,
                          small: players[0].name.length >= 18
                        })}
                      >
                        <span>{players[0].name} </span>
                        <span className="you-marker">
                          {currentPlayer_id === players[0].id && <>(YOU)</>}
                        </span>
                      </div>
                      <div className="first-place-score">
                        {players[0].score}{" "}
                        <span style={{ fontSize: "80%" }}>Points</span>
                      </div>
                    </>
                  )}
                </div>
              </motion.div>
            )}

            {(!players[0].score || activePlayersCount > 1) && (
              <motion.div
                className={classNames({
            "loser-group": true,
            one: activePlayersCount == 1,
            two: activePlayersCount == 2,
            three: activePlayersCount == 3,
            four: activePlayersCount == 4
          })}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 1, duration: 0.35, ease: "circOut" }}
              >
                <div className="loser-title">The Naughty List</div>

                {!players[0].score && (
                  <motion.div
                  className={classNames({
                      "loser": true,
                      "second-place": true,
                      "no-points": true,
                      you: currentPlayer_id === players[0].id
                    })}
                    
                    initial={{ opacity: 0, y: 15 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{
                      delay: 1.25,
                      duration: 0.35,
                      ease: "circOut"
                    }}
                  >
                    <div
                      className="loser-persona second-place"
                      style={{
                        backgroundImage: `url(${getProfileIconFromDisplayName(
                          players[0].name
                        )})`
                      }}
                    ></div>
                                        <div className={classNames({
                      "loser-nameplate": true,
                      "second-place": true,
                      // you: currentPlayer_id === players[0].id
                    })}>
                      <div className="coal first-place"></div>
                      <div className="results">
                        <div className="point-total">
                          {players[0].score}
                          {""}
                          <span className="you-marker">
                            {currentPlayer_id === players[0].id && <>(YOU)</>}
                          </span>
                        </div>
                        <div className="player-name">{players[0].name}</div>
                      </div>
                    </div>
                  </motion.div>
                )}
                {players[1].id && (
                  <motion.div
                  className={classNames({loser: true, 'second-place':true, you: currentPlayer_id === players[1].id})}
                    
                    initial={{ opacity: 0, y: 15 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{
                      delay: 1.25,
                      duration: 0.35,
                      ease: "circOut"
                    }}
                  >
                    <div
                      className="loser-persona second-place"
                      style={{
                        backgroundImage: `url(${getProfileIconFromDisplayName(
                          players[1].name
                        )})`
                      }}
                    ></div>
                    <div className={classNames({
                      "loser-nameplate": true,
                      "second-place": true,
    
                    })}>
                      <div className="coal second-place"></div>
                      <div className="results">
                        <div className="point-total">
                          {players[1].score}
                          {""}
                          <span className="you-marker">
                            {currentPlayer_id === players[1].id && <>(YOU)</>}
                          </span>
                        </div>
                        <div className="player-name">{players[1].name}</div>
                      </div>
                    </div>
                  </motion.div>
                )}

                {players[2].id && (
                  <motion.div
                    className="loser third-place"
                    initial={{ opacity: 0, y: 15 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{
                      delay: 1.35,
                      duration: 0.35,
                      ease: "circOut"
                    }}
                  >
                    <div
                      className="loser-persona third-place"
                      style={{
                        backgroundImage: `url(${getProfileIconFromDisplayName(
                          players[2].name
                        )})`
                      }}
                    ></div>
                  <div className={classNames({
                      "loser-nameplate": true,
                      "third-place": true,
                      you: currentPlayer_id === players[2].id
                    })}>
                      <div className="coal third-place"></div>
                      <div className="results">
                        <div className="point-total">
                          {players[2].score}{" "}
                          <span className="you-marker">
                            {currentPlayer_id === players[2].id && <>(YOU)</>}
                          </span>
                        </div>
                        <div className="player-name">{players[2].name}</div>
                      </div>
                    </div>
                  </motion.div>
                )}

                {players[3].id && (
                  <motion.div
                    className="loser fourth-place"
                    initial={{ opacity: 0, y: 15 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{
                      delay: 1.45,
                      duration: 0.35,
                      ease: "circOut"
                    }}
                  >
                    <div
                      className="loser-persona fourth-place"
                      style={{
                        backgroundImage: `url(${getProfileIconFromDisplayName(
                          players[3].name
                        )})`
                      }}
                    ></div>
                         <div className={classNames({
                      "loser-nameplate": true,
                      "fourth-place": true,
                      you: currentPlayer_id === players[3].id
                    })}>
                      <div className="coal fourth-place"></div>
                      <div className="results">
                        <div className="point-total">
                          {players[3].score}{" "}
                          <span className="you-marker">
                            {currentPlayer_id === players[3].id && <>(YOU)</>}
                          </span>
                        </div>
                        <div className="player-name">{players[3].name}</div>
                      </div>
                    </div>
                  </motion.div>
                )}
              </motion.div>
            )}
          </motion.div>
          <div className="button-group">
            <motion.button
              className="button button-blue snow-one-middle"
              initial={{ scale: 0, y: 10 }}
              animate={{ scale: 1, y: 0 }}
              transition={{ delay: 1.55, duration: 0.35, ease: "circOut" }}
              onClick={() => handleShareClick()}
            >
              Share Results
            </motion.button>

            <motion.button
              className="button button-green snow-one-right"
              initial={{ scale: 0, y: 10 }}
              animate={{ scale: 1, y: 0 }}
              transition={{ delay: 1.6, duration: 0.35, ease: "circOut" }}
              onClick={() => handleDownloadClick()}
            >
              Download Collectible
            </motion.button>
            <Link to="/">
              <motion.button
                className="button button-red snow-two-red"
                initial={{ scale: 0, y: 10 }}
                animate={{ scale: 1, y: 0 }}
                transition={{ delay: 1.65, duration: 0.35, ease: "circOut" }}
              >
                Play Again!
              </motion.button>
            </Link>
          </div>
        </div>
        {/*

          players.map((p, i) => (
            <PlayerResultRow gameId={id} key={`${i}-${p.id}`} playerNumber={i + 1} p={p} PlayerId={player_id}/>
          ))
          
          */}
      </motion.div>
      <Snowfall style={{ position: 'fixed', width: '100vw' }} snowflakeCount={400}/>
    </div>
  );
};
export default Result;
